import { Rocket, RefreshCw, TrendingUp } from "lucide-react";
import { useEffect, useRef, useState } from "react";

const audiences = [
  {
    icon: Rocket,
    title: "New Practices Getting Started",
    desc: "Never marketed before? We build a patient acquisition foundation from scratch — website, SEO, ads — so you start strong.",
  },
  {
    icon: RefreshCw,
    title: "Practices That Tried & Didn't See Results",
    desc: "Burned by another agency? We audit what went wrong and rebuild your marketing with strategies that actually deliver.",
  },
  {
    icon: TrendingUp,
    title: "Established Practices Ready to Scale",
    desc: "Growing beyond referrals? We add new channels — paid ads, direct mail, local SEO — to fill your chairs consistently.",
  },
];

const WhoWeServe = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-28 bg-secondary" ref={ref}>
      <div className="max-w-7xl mx-auto section-padding">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-accent font-semibold text-sm tracking-wide uppercase mb-3">
            Who We Serve
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            Dental Practices at Every Stage of Growth
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {audiences.map((a, i) => (
            <div
              key={a.title}
              className={`bg-card rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow duration-300 ${
                visible ? "reveal-up" : "opacity-0"
              }`}
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="w-11 h-11 rounded-lg bg-accent/10 flex items-center justify-center mb-5">
                <a.icon className="w-5 h-5 text-accent" />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-3">{a.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
